import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";

import logo from "../../../icons/myIcons/logo.png";
import {
  authenticate,
  setLoading,
  setUserDetails,
} from "../../../feature/authSlice";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InputField from "../../components/Fields/inputFields";
import { Button, Modal, Nav, Tab } from "react-bootstrap";
import PrimaryButton from "../../components/Fields/primaryButton";
import Slider from "../../components/swiper/swiper";
import {
  confirmPasswordValidation,
  emailValidation,
  passwordValidation,
} from "../../../function/validation";
import { forgotPasswordApi } from "../../../service/auth/forgotPassword";
import PasswordField from "../../components/Fields/passwordField";
import { resetPasswordApi } from "../../../service/auth/resetPassword";

function ResetPassword(props) {
  const dispatch = useDispatch();
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  useEffect(() => {
    // Get the current URL
    const currentUrl = window.location.href;

    // Create a URLSearchParams object from the URL
    const urlParams = new URLSearchParams(currentUrl);
    const url = new URL(currentUrl);
    // console.log(urlParams, "Params");
    // Get the value of CustomerId parameter
    const codeId = url.searchParams.get("code");
    // console.log(codeId);
    setCode(codeId);
    // const emailVal = urlParams.get("email");
    // setEmail(emailVal);
  }, []);

  const notifyTopRight = (e, s) => {
    if (s == "s") {
      toast.success(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      toast.error(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [loadingActive, setLoadingActive] = useState(false);

  function onSubmit(e) {

        if (
          !passwordValidation(password) ||
          !confirmPasswordValidation(password, confirmPassword)
        ) {
          if (!passwordValidation(password)) {
            setPasswordError(true);
          }
          if (!confirmPasswordValidation(password, confirmPassword)) {
            setConfirmPasswordError(true);
          }
        } else {
          var data = {
            ResponseMessage: "",
            ApiCallStatus: 0,
            StatusCode: 0,
            Message: "",
            Email: "",
            Password: password,
            ConfirmPassword: confirmPassword,
            Code: code,
          };
  
          dispatch(
            resetPasswordApi(
              data,
              (res) => {
                setLoadingActive(false);
                notifyTopRight("Password Changed Successfully", "s");
                setTimeout(() => {
                  navigate("/login");
                }, 2000);
                // console.log(res);
              },
              (err) => {
                setLoadingActive(false);
  
                // console.log(err);
                // notifyTopRight("", "s")
                // console.log(err);
              }
            )
          );
        }
  }

  return (
    <>
      <ToastContainer />
      <div className=" " style={{ background: "#f1f1ff" }}>
        <div
          className="col-xl-12 "
          style={{
            height: "100dvh",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <div className=" border-0 d-flex justify-content-center">
            <div className=" card login-bx" style={{ width: "80%" }}>
              <div className="row custome-row">
                <div
                  className="col-xl-6 col-md-6  text-center d-flex justify-content-center align-items-center "
                  style={{ borderRight: "1px solid lightgray" }}
                >
                  {/* <img src={logo} alt="" style={{ width: '250px' }} /> */}
                  <Slider />
                </div>
                <div className="col-xl-6 col-md-6  d-flex cutome-col align-items-center justify-content-center overflow-auto">
                  <div className="sign-in-your mt-3 " style={{ width: "90%" }}>
                    <div className="row d-flex justify-content-center">
                      <img
                        src={logo}
                        style={{ width: "150px", cursor: "pointer" }}
                        alt=""
                      />
                    </div>
                    <div className="row mt-1"></div>

                    <div className="row mt-4">
                      <span
                        className="login-title"
                        style={{ textAlign: "center", fontWeight: "600" }}
                      >
                        Change Password
                      </span>
                    </div>

                    <div className="row mt-4">
                      <div>
                        {/* <InputField
                          labelName={"Email"}
                          value={email}
                          disabled={true}
                        /> */}

                        <PasswordField
                          inputValue={password}
                          labelName={"New Password"}
                          errorOccured={passwordError}
                          errorMessage={""}
                          onChange={(e) => {
                            e.target.value = e.target.value.toString();
                            //.slice(0, 12)
                            setPasswordError(false);
                            setPassword(e.target.value);
                          }}
                        />
                        <PasswordField
                          inputValue={confirmPassword}
                          labelName={"Confirm Password"}
                          errorOccured={confirmPasswordError}
                          errorMessage={"Password does not match "}
                          onChange={(e) => {
                            e.target.value = e.target.value.toString();
                            //.slice(0, 12)
                            if (
                              confirmPasswordValidation(
                                password,
                                e.target.value
                              )
                            ) {
                              setConfirmPasswordError(false);
                            } else {
                              setConfirmPasswordError(true);
                            }
                            setConfirmPassword(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <div className="form-group text-left d-flex justify-content-between mt-2">
                      <span className="form-check d-inline-block ms-2"></span>
                      <p
                        style={{ color: "#9568FF", cursor: "pointer" }}
                        onClick={() => {
                          navigate("/login");
                        }}
                      >
                        Go back to login ?
                      </p>
                    </div>

                    <PrimaryButton
                      buttonName={"Change Password"}
                      type={"submit"}
                      isLoading={loadingActive}
                      loadingMessage={"Loading..."}
                      style={{
                        width: "100%",
                      }}
                      onClick={() => {
                        onSubmit();
                      }}
                    />

                    <div className="row d-flex justify-content-center ">
                      {/* Apple Signin custom Button for login */}
                      <div className="col-12 d-flex justify-content-center">
                        <div className="buttoncover"></div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <p style={{ textAlign: "center" }}>
                        By continuing, you agree to V2P<br></br>
                        <div className="">
                          <a
                            className="terms-condition-link"
                            href="https://www.vendortopay.com/Home/terms-and-conditions.html"
                            target="_blank"
                            rel="noreferrer"
                          >
                            {"Terms of Service "}
                          </a>
                          <span>and</span>
                          <a
                            href="https://vayana.com/privacy-policy/#:~:text=Vayana%20Network%20will%20not%20sell,the%20processing%20of%20the%20transaction"
                            className="terms-condition-link"
                            target="_blank"
                            rel="noreferrer"
                          >
                            {" Privacy Policy"}
                          </a>
                        </div>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
